import React from "react";
import Template from "../../components/Template";
import api from "../../services/api";
import ConfirmationModal from "../../components/ConfirmationModal";
import SuccessModal from "../../components/SuccessModal";
import { required, isFile, isDate } from "../../utils/validationRules";
import { useValidation } from "../../hooks/useValidation";
import FormLabel from "../../components/FormLabel";
import { useNavigate } from 'react-router-dom';
import { formatDateWithHour } from "../../utils/date";
import config from "../../config";
import { useAuth } from "../../context/AuthContext";
import usePermission from "../../hooks/usePermission";

const Configuracoes = ({ documentoId }) => {
    const navigate = useNavigate();
    const { auth } = useAuth();
    const isAdmin = auth?.user?.role === "ADMIN";
    const podeVerEmpresas = usePermission("VISUALIZAR_EMPRESA");

    const handleNavigateCadastrar = async (e) => {
        e.preventDefault();
        try {
            navigate('/configuracoes/menus');
        } catch (err) {
            console.error('Documentos Error:', err);
            alert(err.response?.data?.msg || 'Erro ao ir para o cadastro');
        }
    };

    return (
        <Template>
            <form className="w-full px-4 py-6 flex flex-col gap-8">
                {/* Título da Página */}
                <div>
                    <h1 className="text-2xl text-stone-800 font-medium">Configurações</h1>
                </div>

                <div className="flex-col justify-start items-start gap-4 flex">
                    {/* Abaixo, cada 'botão' tem 'max-w-[240px]' */}
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                        <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal">
                            Configurar Portfólio
                        </button>
                    </div>
                    {podeVerEmpresas && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/configuracoes/empresas') }}>
                                Empresas
                            </button>
                        </div>
                    )}
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                        <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/configuracoes/usuarios') }}>
                            Cadastrar Usuário
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                        <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/configuracoes/perfis') }}>
                            Cadastrar Perfil
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                        <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/configuracoes/parametros') }}>
                            Parâmetros de Sistema
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                        <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={handleNavigateCadastrar}>
                            Menus Suspensos
                        </button>
                    </div>
                    {isAdmin && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-700 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/configuracoes/auditoria') }}>
                                Auditoria de Dados
                            </button>
                        </div>
                    )}
                </div>
            </form>
        </Template>
    );
};

export default Configuracoes;
